/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const InvertAdjIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Invert Adj',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path d="M8 18.5a10.4 10.4 0 0 0 2.182 6.341L25.919 11.07A10.5 10.5 0 0 0 8 18.5Z" />
    <path
      d="M35 2H1a1 1 0 0 0-1 1v30a1 1 0 0 0 1 1h34a1 1 0 0 0 1-1V3a1 1 0 0 0-1-1Zm-6 16.5a10.466 10.466 0 0 1-18.818 6.341L2 32V4h32l-8.081 7.07A10.472 10.472 0 0 1 29 18.5Z"
    />
  </svg>`;
};
